<script setup lang="ts">
import Card from '@/components/ui/card/Card.vue'

const data = [
  {
    title: 'Facturé',
    value: '20 000 €',
  },
  {
    title: 'Encaissé',
    value: '20 000 €',
  },
  {
    title: 'En attente',
    value: '0 €',
  },
  {
    title: 'Marge brute',
    value: '85 %',
  },
  {
    title: 'Frais pédagogique',
    value: '15 %',
  },
]
</script>

<template>
  <Card title="Détail des performances financières">
    <Card class="w-full max-w-xs py-4" :draggable="false">
      <div class="flex flex-col gap-4">
        <div class="flex items-center">
          <img src="/img/agenceV2.png" alt="Logo" class="w-8 h-8 mr-3" />
          <h1 class="text-sm">ABSKILL | ANGOULEME</h1>
        </div>

        <div class="flex items-center w-full mb-4">
          <img src="/img/catalogueV2.png" alt="Catalogue" class="w-8 h-8 mr-3" />
          <p class="text-sm">TPMA1002 titre professionnel préparateur de commandes en entrepôt</p>
        </div>
      </div>

      <div class="space-y-2">
        <div
          class="flex justify-between text-sm items-center font-medium"
          v-for="item in data"
          :key="item.title"
        >
          <p class="text-gray-700">
            {{ item.title }}
          </p>
          <p class="text-gray-900">
            {{ item.value }}
          </p>
        </div>
      </div>
    </Card>
  </Card>
</template>
